<template>
  <div class="dea-price">
    <span v-if="hasDiscountedPrice" class="dea-heading--medium__s">{{ salePrice }} €</span>
    <span
      v-if="regularPrice"
      :class="{
        'dea-price__regular--discounted dea-heading--light__xs': hasDiscountedPrice,
        'dea-heading--medium__s': !hasDiscountedPrice,
      }"
      >{{ regularPrice }} €</span
    >
  </div>
</template>
<script>
export default {
  name: "EventPrice",
  props: {
    regularPrice: {
      type: Number,
      required: true,
    },
    salePrice: {
      type: Number,
      required: true,
    },
  },
  computed: {
    hasDiscountedPrice() {
      if (this.salePrice && this.salePrice < this.regularPrice) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils"; //sass-lint:disable-line clean-import-paths

.dea-price {
  display: flex;
  flex-direction: row;

  span {
    margin-right: $space-x-small;
  }

  &--vertical {
    flex-direction: column;

    span {
      display: block;

      &:nth-of-type(1) {
        order: 2;
      }

      &:nth-of-type(2) {
        order: 1;
      }
    }
  }

  &__regular--discounted {
    text-decoration: line-through;
  }
}
</style>
